import React from 'react';
import styled, { css } from 'styled-components';
import { Label } from '~/components/Typography/index';

export type Props = {
  dataTestId?: string;
};

const LabelContainer: React.FC<Props> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
);

const LABEL_WIDTH = 130;

const Container = styled(Label)(
  () => css`
    display: inline-block;
    max-width: ${LABEL_WIDTH}px;
    min-width: ${LABEL_WIDTH}px;
  `,
);

export default LabelContainer;
